module.exports = __webpack_public_path__ + "static/zapchasti-fbd14bd6f532bf789c7279f3f839a308.webp";